import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import { Country } from '../../services/types';
import { LocationLink } from '../locationLink';

type Props = {
  country?: Country;
  linkClass?: string;
  iconClass?: string;
  tabIndex?: number;
  iconID?: string;
};

export const SocialLinks: FC<Props> = ({
  country = 'us',
  linkClass,
  iconClass,
  tabIndex,
  iconID,
}) => {
  const countryOptions = {
    us: {
      twitter: 'topgolf',
      tiktok: '@topgolf',
      facebook: 'topgolf',
      instagram: 'topgolf',
      youtube: 'topgolf',
    },
    uk: {
      twitter: 'topgolfuk',
      facebook: 'topgolf',
      instagram: 'topgolfuk',
      youtube: 'c/TopgolfUKTV',
    },
  };

  const social = countryOptions[country];

  return (
    <>
      <li className={classNames('block', iconClass)}>
        <Link
          href={'https://www.instagram.com/' + social.instagram}
          target="_blank"
          id={iconID + '-insta'}
          className={linkClass}
          tabIndex={tabIndex}>
          <span className="sr-only">Follow Topgolf on Instagram</span>
          <i className={classNames('fab fa-instagram fa-2x', iconClass)} aria-hidden="true" />
        </Link>
      </li>
      <li className={classNames('block', iconClass)}>
        <Link
          href="https://www.tiktok.com/@topgolf"
          target="_blank"
          id={iconID + '-tok'}
          className={linkClass}
          tabIndex={tabIndex}>
          <span className="sr-only">Follow Topgolf on TikTok</span>
          <i className={classNames('fab fa-tiktok fa-2x', iconClass)} aria-hidden="true" />
        </Link>
      </li>
      <li className={classNames('block', iconClass)}>
        <Link
          href={'https://www.youtube.com/' + social.youtube}
          target="_blank"
          id={iconID + '-yt'}
          className={linkClass}
          tabIndex={tabIndex}>
          <span className="sr-only">Follow Topgolf on YouTube</span>
          <i className={classNames('fab fa-youtube fa-2x', iconClass)} aria-hidden="true" />
        </Link>
      </li>
      <li className={classNames('block', iconClass)}>
        <Link
          href={'https://facebook.com/' + social.facebook}
          target="_blank"
          id={iconID + '-fb'}
          className={linkClass}
          tabIndex={tabIndex}>
          <span className="sr-only">Follow Topgolf on Facebook</span>
          <i className={classNames('fab fa-facebook fa-2x', iconClass)} aria-hidden="true" />
        </Link>
      </li>
      {country == 'us' && (
        <>
          <li className="block text-center md:hidden">
            <LocationLink
              id={iconID + '-app'}
              tabIndex={tabIndex}
              className={linkClass}
              slug="company/app"
              country={country}>
              <span className="sr-only">Download the Topgolf App</span>
              <i className={classNames('fas fa-mobile-alt fa-2x', iconClass)} aria-hidden="true" />
              <span
                className={classNames(
                  'block text-xs font-shield-semibold-condensed -mt-1',
                  iconClass,
                )}
                aria-hidden="true">
                APP
              </span>
            </LocationLink>
          </li>
        </>
      )}
    </>
  );
};
